module.exports = __webpack_public_path__ + "static/media/rectangle.81ccd8f5.svg";